/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetZReportDates200ResponseInner
 */
export interface GetZReportDates200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetZReportDates200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof GetZReportDates200ResponseInner
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetZReportDates200ResponseInner
     */
    end: Date;
}

/**
 * Check if a given object implements the GetZReportDates200ResponseInner interface.
 */
export function instanceOfGetZReportDates200ResponseInner(value: object): value is GetZReportDates200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    return true;
}

export function GetZReportDates200ResponseInnerFromJSON(json: any): GetZReportDates200ResponseInner {
    return GetZReportDates200ResponseInnerFromJSONTyped(json, false);
}

export function GetZReportDates200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetZReportDates200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'start': (new Date(json['start'])),
        'end': (new Date(json['end'])),
    };
}

export function GetZReportDates200ResponseInnerToJSON(json: any): GetZReportDates200ResponseInner {
    return GetZReportDates200ResponseInnerToJSONTyped(json, false);
}

export function GetZReportDates200ResponseInnerToJSONTyped(value?: GetZReportDates200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'start': ((value['start']).toISOString()),
        'end': ((value['end']).toISOString()),
    };
}

